module.exports = __webpack_public_path__ + "static/img/swiper-4.c29077f8.png";